import { all } from 'redux-saga/effects';
import { requestsSagas } from 'store/ConfigureStore';
import loginSaga from './LoginSaga';
import ChainedActionSaga from './ChainedActionSaga';
import ClientSelectSaga from './ClientSelectSaga';
import { autoSignOutSaga } from './AutoSignOutSaga';
import { watchProviderCommentDetail } from './providerCommentsSaga';

function* rootSaga() {
  yield all([
    ...requestsSagas,
    ...autoSignOutSaga,
    loginSaga(),
    ChainedActionSaga(),
    ClientSelectSaga(),
    watchProviderCommentDetail(),
  ]);
}

export default rootSaga;